module.exports = __webpack_public_path__ + "static/media/placeholder_document.4eedf723.svg";